var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondTierIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17799_56474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 17,
    width: 25,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7412 25.0578C10.8253 24.101 10.7494 22.6175 11.5628 21.5723L14.3196 18.03C14.8253 17.3801 15.6028 17 16.4263 17H30.6178C31.4478 17 32.2305 17.386 32.7357 18.0445L35.4484 21.5801C36.2488 22.6232 36.1704 24.0938 35.2637 25.046L25.4559 35.3455C24.4057 36.4483 22.6473 36.4506 21.5943 35.3506L11.7412 25.0578Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17799_56474)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1465 23.392L15.121 17H31.9342L36.8386 23.392L23.5276 37.3703L10.1465 23.392Z",
    fill: "url(#paint0_linear_17799_56474)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1465 23.3906L16.3067 25.4248L23.5276 37.3688L10.1465 23.3906Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8055 23.3906L30.5427 25.4248L23.5283 37.3688L36.8055 23.3906Z",
    fill: "black",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4252 18.3967L15.0664 16.9961L16.3069 25.4252H23.3901H23.4604H30.5422L31.7827 16.9961L23.4252 18.3967Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0664 16.9961L23.5278 19.8058L31.9344 16.9989L15.0664 16.9961Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.424 18.3965L16.3057 25.4249H30.541L23.424 18.3965Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5266 19.8047L16.3057 25.4241H30.541L23.5266 19.8047Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3067 25.4252L10.1465 23.391L15.0663 16.9961H16.3067V25.4252Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.541 25.4252L36.8403 23.391L31.9206 16.9961H30.6801L30.541 25.4252Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3057 25.4258L23.4914 37.3516L30.541 25.4258H16.3057Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3,
    filter: "url(#filter0_i_17799_56474)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3057 25.4258L23.4914 37.3516L30.541 25.4258H16.3057Z",
    fill: "black"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "#2C3561",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_17799_56474",
    x: 16.3057,
    y: 21.4258,
    width: 14.2354,
    height: 15.9258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17799_56474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17799_56474",
    x1: 23.4925,
    y1: 17,
    x2: 23.4925,
    y2: 37.3703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#003B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondTierIcon);
export default __webpack_public_path__ + "static/media/DiamondTierIcon.acb5ec75.svg";
export { ForwardRef as ReactComponent };